module.exports = "/_next/static/images/trezor_logo_suite-b1e87daf882087643cfa39f7c9cdfab1.svg";